export default "__VITE_ASSET__ac250799__"